import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider } from './context/AuthContext';
import { PlatformProvider } from './context/PlatformContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import CreatorPublic from './pages/CreatorPublic';
import AuthCallback from './pages/AuthCallback';
import PaymentStatus from './pages/PaymentStatus';
import NotFound from './pages/NotFound';
import Admin from './pages/Admin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import FAQ from './pages/FAQ';
import Guide from './pages/Guide';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Changelog from './pages/Changelog';
import Protected from './components/Protected';
import HelpFAB from './components/HelpFAB';
import CompleteProfile from './pages/CompleteProfile';
import OverlayAlert from './pages/overlay/OverlayAlert';
import OverlayGoal from './pages/overlay/OverlayGoal';
import OverlayTicker from './pages/overlay/OverlayTicker';
import OverlaySubathon from './pages/overlay/OverlaySubathon';
import OverlayLeaderboard from './pages/overlay/OverlayLeaderboard';
import OverlayMediaShare from './pages/overlay/OverlayMediaShare';
import OverlayVoting from './pages/overlay/OverlayVoting';
import OverlayQR from './pages/overlay/OverlayQR';
import VerifyEmail from './pages/VerifyEmail';
import { useEffect } from 'react';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Handle session_id in URL fragment (from Emergent Auth)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/dashboard/*"
        element={
          <Protected>
            <Dashboard />
          </Protected>
        }
      />
      <Route path="/pay/:orderId" element={<PaymentStatus />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/panduan" element={<Guide />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/changelog" element={<Changelog />} />
      <Route path="/complete-profile" element={<CompleteProfile />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/u/:username" element={<CreatorPublic />} />
      {/* Overlay routes (token-based auth, no login required) */}
      <Route path="/overlay/:token/alert" element={<OverlayAlert />} />
      <Route path="/overlay/:token/goal" element={<OverlayGoal />} />
      <Route path="/overlay/:token/ticker" element={<OverlayTicker />} />
      <Route path="/overlay/:token/subathon" element={<OverlaySubathon />} />
      <Route path="/overlay/:token/leaderboard" element={<OverlayLeaderboard />} />
      <Route path="/overlay/:token/media" element={<OverlayMediaShare />} />
      <Route path="/overlay/:token/vote" element={<OverlayVoting />} />
      <Route path="/overlay/:token/qr" element={<OverlayQR />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PlatformProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppRouterWrapper />
          </BrowserRouter>
        </PlatformProvider>
      </AuthProvider>
    </div>
  );
}

function AppRouterWrapper() {
  const location = useLocation();
  const isOverlay = location.pathname.startsWith('/overlay');

  return (
    <>
      <AppRouter />
      {!isOverlay && (
        <>
          <HelpFAB />
          <Toaster
            position="top-center"
            toastOptions={{
              className: 'border-2 border-foreground shadow-brutal bg-white !text-foreground font-medium',
            }}
          />
        </>
      )}
    </>
  );
}

export default App;
